module.exports = __webpack_public_path__ + "img/iframe-top.2a63d304.png";